<template>
  <div class="content">
      <el-form :model="orderForm" ref="orderForm" :inline="true">
          <el-form-item prop="userId">
              <el-cascader
              placeholder="公司名"
              ref="myCascader"
              :options="agentList"
              :props="{value : 'userId' , checkStrictly: true,emitPath:false }"
              :show-all-levels="false"
              clearable
              style="width:210px;margin-right:30px;"
              v-model="orderForm.userId"
              @change="search"
              filterable
            >
              <template slot-scope="{ node, data }">
                <span>[{{ data.username }}]{{ data.label }}</span>
                <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
              </template>
            </el-cascader>
          </el-form-item>
          <el-form-item prop="orderStatus">
              <el-select v-model="orderForm.orderStatus" filterable placeholder="订单状态" @change="search" clearable>
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item prop="orderNum">
              <el-input v-model="orderForm.orderNum"  placeholder="订单号"></el-input>
          </el-form-item>
          <el-form-item prop="withdrawalOrder">
              <el-input v-model="orderForm.withdrawalOrder"  placeholder="提现订单号"></el-input>
          </el-form-item>
          <el-form-item prop="searchTime">
            <el-date-picker 
              style="margin-right:30px"
              value-format="yyyy-MM-dd"
              v-model="orderForm.searchTime"
              @change="search"
              type="daterange"
              range-separator="-"
              start-placeholder="付款开始日期"
              end-placeholder="付款结束日期">
            </el-date-picker>
          </el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
      </el-form>
      <!-- 表格 -->
      <div class="table" style="margin-top: 10px">
        <el-table :data="tableData" border v-loading="loading">
          <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
          <el-table-column prop="companyName" label="公司名称" align="center" width="200px" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              [{{scope.row.username}}]{{scope.row.companyName}}
            </template>
          </el-table-column>
          <el-table-column prop="orderNum" label="订单号" align="center" width="200px"></el-table-column>
          <el-table-column prop="withdrawalOrder" label="提现订单号" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="orderMoney" label="提现到账金额" align="center"></el-table-column>
          <el-table-column prop="orderStatus" label="状态" align="center">
            <template slot-scope="scope">
              <el-tag type="warning" v-if="scope.row.orderStatus=='1'">支付中</el-tag>
              <el-tag type="success" v-else-if="scope.row.orderStatus=='2'">支付成功</el-tag>
              <el-tag type="danger" v-else>支付失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="payMode" label="提现方式" align="center">
            <template slot-scope="scope">
              {{inventoryPayMode(scope.row.type)}}
            </template>
          </el-table-column>
          <el-table-column prop="mchId" label="付款账号" align="center" ></el-table-column>
          <el-table-column prop="payeeId" label="收款账号" align="center" width="160px"></el-table-column>
          <el-table-column prop="payeer" label="收款人姓名" align="center" width="160px"></el-table-column>
          <el-table-column prop="orderTime" label="付款时间" align="center" width="200px"></el-table-column>
          <el-table-column prop="payTime" label="付款到账时间" align="center" width="200px"></el-table-column>
          <el-table-column prop="reason" label="失败原因" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column fixed="right" label="操作" align="center">
						<template slot-scope="scope">
              <el-button  type="primary" size="mini" plain icon="el-icon-view" @click="orderView(scope.row.withdrawalId)" >查看</el-button>
						</template>
					</el-table-column>
        </el-table>
      </div>
      <div class="block" style="margin-top: 30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
  </div>
</template>
<script>
import { agentTreeList } from "@/api/api.js"; //代理商
import { withdrawalOrderPage } from "@/api/api.js"; //提现订单记录
export default {
  name:'auditOrder',
  data() {
    return {
      loading:false,
      orderForm:{
        userId:undefined,
        orderStatus:undefined,
        orderNum:undefined,
        withdrawalOrder:undefined,
        searchTime:[],
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total: 0,
      // 充值记录的操作
      options: [
        {
          value: "1",
          label: "支付中"
        },
        {
          value: "2",
          label: "支付成功"
        },
        {
          value: "0",
          label: "支付失败"
        },
      ],
      agentList:[]
    };
  },
  methods: {
    initData() {
      let params = {
        model:{
          ...this.addDateRange(this.orderForm, this.orderForm.searchTime)
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      withdrawalOrderPage(params).then(res=>{
          this.loading = false
          if(res.data.code==200){
            this.tableData = res.data.data.records;
            this.total = res.data.data.total;
          }else{
            this.$message.error(res.data.message);
          }
      })

    },
    inventoryPayMode(status) {
      let obj = {
        1: "微信",
        2: "支付宝",
        3: "余额",
        4: "银行卡对公账户"
      };
      return obj[status];
    },
    // 搜索
    search(){
      this.initData()
    },
    // 获取初始化代理商列表
    agentTreeListMethod(){
      agentTreeList().then(res => {
        if (res.data.code == 200) {
          this.agentList = res.data.data;
        }
      });
    },
    // 用户充值记录的重置
    reset(){
      this.resetForm("orderForm");
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData()
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData()
    },
    orderView(id){
      this.$router.push(`/scale/withdrawDetail/`+id);
    }
  },
  mounted() {

  },
  created() {
    this.agentTreeListMethod();
    this.initData()
  }
};
</script>
<style scoped lang="less">
  
</style>


